import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react'
import { Box, Card, CardContent, Typography, Stack, Chip, Avatar } from '@mui/material';
import RecordVoiceOverRoundedIcon from '@mui/icons-material/RecordVoiceOverRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import { BASE_URL, getBearerToken, SOCKET_BASE_URL } from '../../utils/Apis';
import { Constants } from '../../utils/Constants';
import AppShell from '../../layouts/AppShell';

const A_participants = () => {

    const [data, setdata] = useState([])
    const [unmuteData, setunmuteData] = useState([])
    const [_id, set_id] = useState("")
    const socketRef = useRef(null);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         handleParticipantClick();
    //     }, 2000); // 2000ms = 2 seconds

    //     // Cleanup on unmount
    //     return () => clearInterval(interval);
    // }, []);


    // const handleParticipantClick = () => {
    //     let token = localStorage.getItem(Constants.APP_KEY)

    //     let config = {
    //         method: 'get',
    //         maxBodyLength: Infinity,
    //         url: BASE_URL + 'fetchSaveParticipants',
    //         headers: {
    //             'Authorization': 'Bearer ' + token
    //         }
    //     };

    //     axios.request(config)
    //         .then((response) => {
    //             console.log(JSON.stringify(response.data.data?.participants));
    //             setdata(response.data.data?.participants)
    //             setunmuteData(response.data.data?.participants.filter((item) => item.isMuted == false))
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }

    const connectWebSocket = () => {
        // if (!_id) return alert("Please enter User ID");

        // if (_id) {
        // Connect to WebSocket server
        socketRef.current = new WebSocket(SOCKET_BASE_URL); // Update port if using HTTPS

        socketRef.current.onopen = () => {
            console.log('WebSocket connected', localStorage.getItem(Constants.USERID));

            // Send REGISTER message
            socketRef.current.send(JSON.stringify({
                type: 'REGISTER',
                _id: localStorage.getItem(Constants.USERID)
            }));
        };

        socketRef.current.onmessage = (event) => {
            const data = JSON.parse(event.data);
            console.log('Received:', data);

            if (data.type === 'USER_UPDATED') {
                setdata(data.payload.participants);
                setunmuteData(data.payload.participants.filter((item) => item.isMuted == false));
            }
        };

        socketRef.current.onclose = () => {
            console.log('WebSocket disconnected');
        };

        socketRef.current.onerror = (err) => {
            console.error('WebSocket error:', err);
        };
        // }
    };

    useEffect(() => {
        // fetch_users()
        return () => {
            console.log("unmount")
        }
    }, [])
    useEffect(() => {
        connectWebSocket()
    }, [])

    useEffect(() => {
        return () => {
            if (socketRef.current) socketRef.current.close();
        };
    }, []);

    // const fetch_users = async () => {
    //     getBearerToken("users").then((result) => {
    //         if (result.error == 0) {
    //             console.log(result.data)
    //             set_id(result?.data?._id)
    //         } else {
    //         }
    //     })
    // }


    return (
        <AppShell title="Participants" breadcrumb={['Participants']}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2.5} sx={{ mb: 3 }}>
                <Card sx={{ flex: 1, minWidth: 200 }}>
                    <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar variant="rounded" sx={{ bgcolor: 'primary.main', width: 52, height: 52 }}>
                            <RecordVoiceOverRoundedIcon />
                        </Avatar>
                        <Box>
                            <Typography variant="h3" sx={{ lineHeight: 1 }}>{unmuteData.length}</Typography>
                            <Typography variant="subtitle2" color="text.secondary">Total Speaking</Typography>
                        </Box>
                    </CardContent>
                </Card>
                <Card sx={{ flex: 1, minWidth: 200 }}>
                    <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar variant="rounded" sx={{ bgcolor: 'success.main', width: 52, height: 52 }}>
                            <GroupsRoundedIcon />
                        </Avatar>
                        <Box>
                            <Typography variant="h3" sx={{ lineHeight: 1 }}>{data.length}</Typography>
                            <Typography variant="subtitle2" color="text.secondary">Online Users</Typography>
                        </Box>
                    </CardContent>
                </Card>
            </Stack>

            <Card sx={{ mb: 3 }}>
                <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                    <Typography variant="h4" sx={{ mb: 2 }}>Unmute Participants</Typography>
                    {unmuteData && unmuteData.length > 0 ? (
                        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                            {unmuteData?.map((item, i) => (
                                <Chip
                                    key={i}
                                    label={item.userName}
                                    color={item.isMuted ? "error" : "success"}
                                    variant="outlined"
                                />
                            ))}
                        </Stack>
                    ) : (
                        <Typography variant="body2" color="text.secondary">No speaking participants.</Typography>
                    )}
                </CardContent>
            </Card>

            <Card>
                <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                    <Typography variant="h4" sx={{ mb: 2 }}>Participants</Typography>
                    {data && data.length > 0 ? (
                        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                            {data?.map((item, i) => (
                                item.userName != "" ? (
                                    <Chip
                                        key={i}
                                        label={item.userName}
                                        color={item.isMuted ? "error" : "success"}
                                        variant="outlined"
                                    />
                                ) : null
                            ))}
                        </Stack>
                    ) : (
                        <Typography variant="body2" color="text.secondary">No participants online.</Typography>
                    )}
                </CardContent>
            </Card>
        </AppShell>
    )
}

export default A_participants
